export const GET_USER_INFO = 'user/getUserInfo';

export const actionTypes = {
  GET_USER_INFO,
};
